import Loadable from '../../react-loadable';
import { BoxSelectionType } from './types';

const BoxSelection = Loadable({
  name: 'BoxSelection', loader: () => import(
    /* webpackChunkName: "ui_commont" */
    './BoxSelection')
}) as BoxSelectionType;

export type { BoxSelectionProps, BoxSelectionType } from './types';

export default BoxSelection;
